export enum InventoryMenuEnum {
    overview = 0,
    propertiesByNeighborhood,
    projectsAndProperties,
    project,
    unit,
    unitTransaction
}
